/** @format */

import { memo } from 'react'
import { CopyBlock, ocean } from 'react-code-blocks'

import styles from 'dir/styles/courses.module.css'

export const _3 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>3 - Reselect</h2>
    <p className={styles.description}>
      Каждый раз когда происходит действие в любом месте приложения, все подключенные компоненты вызывают функцию{' '}
      <code className={styles.code}>mapStateToProps</code>, в результате чего вызываются все селекторы, это может бить
      по производительности при работе с большими структурами данных.{' '}
    </p>
    <p className={styles.description}>
      <b>Reselect</b> — библиотека для создания селекторов с встроенной мемоизацией аргументов. Позволяет комбинировать
      селекторы, тем самым отбрасывая необходимость кешировать все состояние, и использовать мемоизированные значения
      функций.{' '}
    </p>
    <p className={styles.description}>
      Тоесть селектор созданный с помощью <code className={styles.code}>Reselect</code> вернет закешированный результат,
      если ничего не изменилось. Это позволяет выполнять вычисления только в том случае, если в соответствующей части
      дерева состояний произошли изменения.{' '}
    </p>
    <CopyBlock text={`npm install reselect`} language="javascript" showLineNumbers={false} theme={ocean} />
    <p className={styles.description}>
      <b>createSelector</b> - основной метод, позволяет создавать селекторы на основе композиции других селекторов,
      мемоизирует аргументы.{' '}
    </p>
    <p className={styles.description}>
      Не используйте <code className={styles.code}>createSelector</code> для селекторов которые просто обращаются к полю
      в <code className={styles.code}>state</code> и возвращют его значение, это излишне.{' '}
    </p>
    <CopyBlock
      text={`import { createSelector } from 'reselect';

export const getAllPosts = state => state.posts.items;

export const isPostsLoading = state => state.posts.loading;

const getSelectedTags = state => state.posts.selectedTags;

export const getPostsWithTags = createSelector(
  [getAllPosts, getSelectedTags],
  (posts, tags) =>
    posts.filter(post => tags.some(tag => post.tags.includes(tag))),
);

export const getPostById = createSelector(
  [(state, id) => id, getAllPosts],
  (id, posts) => posts.find(post => post.id === id),
);

// session-selectors.js
export const getUserName = state => state.session.user.name;
export const isUserAuthenticated = state => state.session.authenticated;`}
      language="javascript"
      showLineNumbers={false}
      theme={ocean}
    />
  </section>
))
